(function($) {

    var _max_height = 0;

    $( ".carousel-container .carousel-item .text-container" ).height('unset');

    $( ".carousel-container .carousel-item .text-container" ).each(function(  ) {

        $( this ).parent('.carousel-item').css("display", "block");

        if ($(this).height() > _max_height) {
            _max_height = $( this).height();
        }

        $( this ).parent('.carousel-item').removeAttr("style");

    });

    $( ".carousel-container .carousel-item .text-container" ).height(_max_height + 20);

    $( window ).on( "resize", function() {

        _max_height = 0;

        $( ".carousel-container .carousel-item .text-container" ).height('unset');

        $( ".carousel-container .carousel-item .text-container" ).each(function(  ) {

            $( this ).parent('.carousel-item').css("display", "block");

            if ($(this).height() > _max_height) {
                _max_height = $( this).height();
            }

            $( this ).parent('.carousel-item').removeAttr("style");

        });

        $( ".carousel-container .carousel-item .text-container" ).height(_max_height + 20);

    } );


})(jQuery);